import { useNavigate } from "react-router-dom";
import { getUser } from '../lib/assets';

// --- Welcome Screen ---
function WelcomeScreen({setHasCaregiver}) {
  const navigate = useNavigate()

  const onSelectCaregiver = (hasCaregiverSelection) => {
    setHasCaregiver(hasCaregiverSelection);
    navigate("/participant")
  };

  getUser()

  return (
    <div className="screen active">
      <h1>Welcome to the Visualization Tool App</h1>
      <p>
        This tool pairs sensor data (with timestamps) with the correct ADLs for the client.
        Since the client has a cognitive disorder, both the client and their caregiver will label the previous day’s activities.
      </p>
      <p>Do you have a caregiver who will help with the annotation?</p>
      <button onClick={() => onSelectCaregiver(true)}>Yes</button>
      <button onClick={() => onSelectCaregiver(false)}>No</button>
    </div>
  );
}


export default WelcomeScreen